import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-formhijo',
  templateUrl: './formhijo.component.html',
  styleUrls: ['./formhijo.component.scss']
})
export class FormhijoComponent implements OnInit {
    dynamicForm: FormGroup;
    queryString: any;
    currparent: any;
    constructor(@Inject(MAT_DIALOG_DATA) public data: {data_sel: any},
                public dialogRef: MatDialogRef<FormhijoComponent>,
                private fb: FormBuilder,) {

        this.dynamicForm = this.fb.group({
            nombre: new FormControl('', [Validators.required]),
            valor: new FormControl('', [Validators.required]),
            idPadre: new FormControl('', [Validators.required])

        });

    }

    ngOnInit(): void {

        this.dynamicForm.controls["idPadre"].setValue(this.data.data_sel.idPadre)
    }
    private convertValid(obj) {
        //todo: para obetner desde la bdd
        return [];
    }
    Guardar(){
        this.dialogRef.close(this.dynamicForm.controls)
    }
}
